import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadBannerTextHIWWhyChooseWkdaFaq,
  CarleadStepCompoundCustomerPopupCustomerCounter,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStepCompoundCustomerPopupCustomerCounter}
      content={CarleadBannerTextHIWWhyChooseWkdaFaq}
      showCounterHeadline={true}
      unmappedLpRedesign
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
